import { render, staticRenderFns } from "./topButton.vue?vue&type=template&id=f5fe3654&scoped=true&"
import script from "./topButton.vue?vue&type=script&lang=js&"
export * from "./topButton.vue?vue&type=script&lang=js&"
import style0 from "./topButton.vue?vue&type=style&index=0&id=f5fe3654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fe3654",
  null
  
)

export default component.exports